export const FIANLY_NAME = 'Fianly';

export const installationDisplayName = name =>
  !name || name.trim().toLowerCase() === 'chatwoot' ? FIANLY_NAME : name;

// Only transform product copy, before user values are interpolated.
// Preserve URLs, email addresses, markup attributes, code and i18n placeholders.
const PROTECTED_COPY =
  /(<code\b[^>]*>[\s\S]*?<\/code>|<pre\b[^>]*>[\s\S]*?<\/pre>|<[^>]+>|`[^`]*`|(?:https?:\/\/|www\.)[^\s<>]+|[\w.+-]+@[\w.-]+|\{[^}]*\})/gi;

export const replaceProductName = text =>
  text
    .split(PROTECTED_COPY)
    .map((part, index) =>
      index % 2
        ? part
        : part.replace(/(?<![\w@./-])chatwoot(?![\w/-]|\.[\w-])/gi, FIANLY_NAME)
    )
    .join('');

export const brandMessages = messages => {
  if (typeof messages === 'string') return replaceProductName(messages);
  if (messages === null || typeof messages !== 'object') return messages;
  if (Array.isArray(messages)) return messages.map(brandMessages);
  return Object.fromEntries(
    Object.entries(messages).map(([key, value]) => [key, brandMessages(value)])
  );
};
